import React, { memo, lazy, Suspense } from 'react';
import Dialog from '@material-ui/core/Dialog';
import useStyles from './WatchlistTopicStyles';
import ManageWatchlistSkeleton from './ManageWatchlistSkeleton';

const ManageWatchlistContent = lazy(() => import('./ManageWatchlistContent'));

const ManageWatchlist = () => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        fullWidth={true}
        open={true}
        keepMounted={false}
        maxWidth="md"
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        className={classes.dialogContainer}>
        <Suspense fallback={<ManageWatchlistSkeleton />}>
          <ManageWatchlistContent />
        </Suspense>
      </Dialog>
    </>
  );
};

export default memo(ManageWatchlist);
